import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FAQ = ({ items, title = "Frequently Asked Questions", subtitle }) => (
  <section className="py-20 md:py-28" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-5 sm:px-8">
      <div className="mb-10">
        <p className="text-xs uppercase tracking-[0.25em] text-leaf mb-4">FAQs</p>
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-navy leading-none">{title}</h2>
        {subtitle && <p className="mt-4 text-muted-foreground">{subtitle}</p>}
      </div>
      <Accordion type="single" collapsible className="w-full">
        {items.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-border">
            <AccordionTrigger className="text-left font-heading text-lg font-medium text-navy hover:text-leaf hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent forceMount className="[[data-state=closed]>&]:hidden text-muted-foreground text-base leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
